/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetListConstraintsResponse {
    getFixupPrototypeFunction() { return BudgetListConstraintsResponse.fixupPrototype; }

    static newInstance(model: Partial<BudgetListConstraintsResponse>): BudgetListConstraintsResponse {
        let obj = Object.assign(new BudgetListConstraintsResponse(), model);
        BudgetListConstraintsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetListConstraintsResponse>): BudgetListConstraintsResponse {
        if (!model) return null;
        return BudgetListConstraintsResponse.newInstance(<BudgetListConstraintsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetListConstraintsResponse) {
        if (!obj) return;

        models.BudgetListConstraintsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetListConstraintsResponse): boolean {
        Object.setPrototypeOf(obj, BudgetListConstraintsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * budget filter list status
     */
    status: string;

    /**
     * budget filter list status message
     */
    message: string;

    /**
     * constraints listed for given filter key, cloud_account_id and tenant_id
     */
    data: any;

}
